module.exports = __webpack_public_path__ + "img/ellen.e67d48e2.jpeg";